module.exports = __webpack_public_path__ + "img/5400.72c367a0.jpg";